import React, { useState, useEffect, useContext, useRef } from "react";
import TableStyle from "components/Content/Table/TableStyle.module.css";
import { styled, alpha } from '@mui/material/styles';
// import { AppContext } from "AppContext";
import TableAllData from "components/Content/CustomTable/TableAllData";
import { apiGet, apiPost } from "app/Services/ApiService";
import { apiUrls } from "common/ApiUrls";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Checkbox, Grid, FormControl, Input, Divider } from "@mui/material";
import LoadingButton from '@mui/lab/LoadingButton';
import ModalStyles from "components/Content/Modal/ModalStyles.module.css";
import ButtonStyle from "components/Button/ButtonStyle.module.css";

import EmployeeBenefitsMenu from "components/Menu/EmployeeBenefitsMenu";
import EmployeeProfile from "area/employer/EmployeeCensus/EmployeeProfile";
import moment from "moment";
import { Utils } from "common/Utils";
import * as Yup from 'yup';
import AximTooltip from "components/AximTooltip";

const CensusPriorDataModal = ({ openPriorDataModal, setOpenPriorDataModal, priorData}) => {

  const [priorDataDetail, setPriorDataDetail] = React.useState([]);
  const [priorDataFiles, setPriorDataFiles] = React.useState([]);
  const [priorDataDetailCounts, setPriorDataDetailCounts] = useState({
    New: 0,
    Rehire: 0,
    Term: 0,
    Update: 0
  });

  const [openPriorDataDetailModal, setOpenPriorDataDetailModal] = React.useState(false);

  const showPriorDataDetail = (row) => {
    //openPriorDataDetailModal
    console.log(row.values.censusManagementID);

    const selectedCompany = localStorage.getItem(`selectedCompanyId`);
    apiGet(apiUrls.getPriorCensusManagementDetail(selectedCompany, row.values.censusManagementID)).then(
      (cesResponse) => {
        console.log(cesResponse, 'census detail');

        let censusData = JSON.parse(cesResponse.data.censusData);
        let NumberOfNew = censusData.filter(function (elm) {
          return (elm.Action == "Add");
        }).length;
        let NumberOfRehire = censusData.filter(function (elm) {
          return (elm.ChangeType == "Rehire");
        }).length;
        let NumberOfTerm = censusData.filter(function (elm) {
          return (elm.ChangeType == "Term");
        }).length;

        let NumberOfChange = censusData.filter(function (elm) {
          return (elm.Action == "Update" && (!elm.hasOwnProperty("ChangeType") || elm.ChangeType == "Change"));
        }).length;

        setPriorDataDetailCounts({
          New: NumberOfNew,
          Rehire: NumberOfRehire,
          Term: NumberOfTerm,
          Update: NumberOfChange,
        });
        setOpenPriorDataDetailModal(true)
        setOpenPriorDataModal(false)
      });
    apiGet(apiUrls.getPriorCensusManagementDetailFiles(selectedCompany, row.values.censusManagementID)).then(
      (cesResponse) => {
        console.log(cesResponse, 'census detail files');
        setPriorDataFiles(cesResponse.data)
      }
    );

  }

  const priorDataFileColumns = [
    {
      Header: "File Name",
      accessor: "fileName",
      Cell: ({ row }) => (
        <Box >
          <Button onClick={() => showPriorDataDetail(row)}>
            {row.values.fileName}
          </Button>
        </Box>
      )
    },
    {
      Header: "fileID",
      accessor: "fileID",
      style: {
        display: "none"
      },
      cellStyle: {
        display: "none"
      }
    },
    {
      Header: "File Type",
      accessor: "fileTypeName"
    },
    {
      Header: "Create Date",
      accessor: "createDate",
      Cell: ({ row }) => (
        <Box >
          {Utils.formatDate(row.values.createDate)}
        </Box>
      )
    },
    {
      Header: "Total Rows",
      accessor: "totalRows"
    },
    {
      Header: "Error",
      accessor: "errorCount"
    },
    {
      Header: "Warning",
      accessor: "warningCount"
    }
  ];

  const priorDataColumns = [
    {
      Header: "HW Benefit Date",
      accessor: "hwBenefitDate",
      Cell: ({ row }) => (
        <Box >
          <Button onClick={() => showPriorDataDetail(row)}>
            {Utils.formatDate(row.values.hwBenefitDate)}
          </Button>
        </Box>
      )
    },
    {
      Header: "censusManagementID",
      accessor: "censusManagementID",
      style: {
        display: "none"
      },
      cellStyle: {
        display: "none"
      }
    },
    {
      Header: "employeeFileErrorCount",
      accessor: "employeeFileErrorCount",
      style: {
        display: "none"
      },
      cellStyle: {
        display: "none"
      }
    },
    {
      Header: "enrollmentFileErrorCount",
      accessor: "enrollmentFileErrorCount",
      style: {
        display: "none"
      },
      cellStyle: {
        display: "none"
      }
    },
    {
      Header: "Status",
      accessor: "statusCode",
      Cell: ({ row }) => (
        <Box >
          {row.values.statusCode} {(row.values.employeeFileErrorCount > 0 || row.values.enrollmentFileErrorCount > 0) ? (' WITH ERROR') : ('')}
        </Box>
      )
    },
    {
      Header: "Create by",
      accessor: "createUser"
    },
    {
      Header: "Create Date",
      accessor: "createDate",
      Cell: ({ row }) => (
        <Box >
          {Utils.formatDate(row.values.createDate)}
        </Box>
      )
    },
    {
      Header: "Update by",
      accessor: "updateUser"
    },
    {
      Header: "Update Date",
      accessor: "updateDate",
      Cell: ({ row }) => (
        <Box >
          {Utils.formatDate(row.values.updateDate)}
        </Box>
      )
    }
  ];

  return (
    <>
      <Dialog
        open={openPriorDataModal}
        onClose={() => setOpenPriorDataModal(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={ModalStyles.empDataModal}
        maxWidth="lg"
      >
        <DialogTitle id="alert-dialog-title">
          Prior Data
        </DialogTitle>
        <DialogContent className={ModalStyles.CustomTabsWrapper}>
          <TableAllData columns={priorDataColumns} data={priorData} />
        </DialogContent>
        <DialogActions className={ButtonStyle.buttonWrapper}>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => setOpenPriorDataModal(false)}
            className={ButtonStyle.CcancelBtn}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>


      <Dialog
        open={openPriorDataDetailModal}
        onClose={() => setOpenPriorDataDetailModal(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={ModalStyles.empDataModal}
        maxWidth="lg"
      >
        <DialogTitle id="alert-dialog-title">
          Prior Submitted Data
        </DialogTitle>
        <DialogContent className={ModalStyles.CustomTabsWrapper}>
          <table class="table">
            <thead>
              <tr>
                <th>New</th><th>Rehire</th><th>Term</th><th>Update</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{priorDataDetailCounts.New}</td><td>{priorDataDetailCounts.Rehire}</td><td>{priorDataDetailCounts.Term}</td><td>{priorDataDetailCounts.Update}</td>
              </tr>
            </tbody>
          </table>

          <table class="table">
            <thead>
              <tr>
                <th>File Name</th><th>File Type</th><th>Create Date</th><th>Total Rows</th><th>Error</th><th>Warning</th>
              </tr>
            </thead>
            <tbody>
              {
                priorDataFiles.map((f) => (
                  <tr>
                    <td>{f.fileName}</td><td>{f.fileTypeName}</td><td>{Utils.formatDate(f.createDate)}</td><td>{f.totalRows}</td>
                    <td>
                      {
                        /*
                      <Button onClick={()=>downloadFileError(f.fileID)} disabled={f.errorCount==0}>
                      {f.errorCount}
                      </Button>
                      */
                      }
                      <AximTooltip title="Please reach out to us to these errors resolved">
                        <span>{f.errorCount}</span>
                      </AximTooltip>
                    </td>
                    <td>{f.warningCount}</td>
                  </tr>
                ))
              }
            </tbody>
          </table>

        </DialogContent>
        <DialogActions className={ButtonStyle.buttonWrapper}>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => setOpenPriorDataDetailModal(false)}
            className={ButtonStyle.CcancelBtn}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
};

export default CensusPriorDataModal;